import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mediaUrl',
  standalone: true,
})
export class MediaUrlPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    return value && this.baseMediaUrl ? `${this.baseMediaUrl}/${value}` : '';
  }

  constructor(@Inject('BASE_MEDIA_URL') private baseMediaUrl: string) {}
}
